import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {Title} from "@angular/platform-browser";

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet],
})
export class AppComponent {
  /**
   * Constructor
   */
  constructor(private titleService:Title) {
  
    let brand = "esayworkmobilecouk";
    let title= "WorkMobile";

    brand = window.location.hostname.replace(/\./g, '');    

    if (brand.includes('fieldpal')){
      title="FieldPal";
    }

    this.titleService.setTitle(title);
  }
}
